export default __webpack_public_path__ + "static/media/paper-white.793bd885.svg";